<template>
  <info-dialog v-model="modelValue" title="Vacina">
    <img src="/assets/attendance-form/vaccine.png" alt="" />
    <p class="reference">
      Desenvolvido a partir de 1. Sociedade Brasileira de Dermatologia. (2020). Consenso Brasileiro de Psoríase 2020. 2.
      Takeda Pharmaceutical Company Limited. (2023). Bula da Qdenga (vacina dengue 1, 2, 3 e 4 atenuada) - novo
      registro. 3. Sanofi Pasteur. (n.d.). Bula da Dengvaxia. 4. GlaxoSmithKline. (2021). Bula do Shingrix.
    </p>
  </info-dialog>
</template>

<script>
import { ComputedOptions } from 'vue'
import InfoDialog from '@/components/NewAttendanceForm/FormNodes/InfoDialogs/InfoDialog.vue'

export default {
  name: 'HanifinAndRajkaDialog',
  components: { InfoDialog },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    /** @type {ComputedOptions<boolean>} */
    modelValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>

<style scoped>
.reference {
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
}
</style>
